import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento/${id}`)
}
export async function getComissoes (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento?all=1&active=true&` + serialize(dados), 'GET')
}
export async function getComissoesLiberado (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento/liberado?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento`, 'POST', dados)
}
export async function addArray (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento/importar`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento/${dados.id}`, 'PUT', dados)
}
export async function status (dados) {
  return sessaoFetchLoading(`base`, `/tabela/comissionamento/status`, 'POST', dados)
}



// WEBPACK FOOTER //
// ./src/api/comissao.js